import {
  EVENT_ADDITIONAL_PICTURES_ACTIONS,
  EventAdditionalPicturesStateInterface,
} from "../actions/event-additional-pictures.actions";

const initialState: EventAdditionalPicturesStateInterface = {
  pictureSets: null,
};

export function eventAdditionalPicturesReducer(
  state: EventAdditionalPicturesStateInterface = initialState,
  action
) {
  switch (action.type) {
    case EVENT_ADDITIONAL_PICTURES_ACTIONS.SET_EVENT_ADDITIONAL_PICTURES:
      state.pictureSets = action.payload;

      return Object.assign({}, state);
    case EVENT_ADDITIONAL_PICTURES_ACTIONS.UPDATE_EVENT_ADDITIONAL_PICTURES:
      if (
        state.pictureSets.pictureSets &&
        state.pictureSets.pictureSets.find(
          (ps) => ps.setId == action.payload.setId
        )
      ) {
        state.pictureSets.pictureSets.find(
          (ps) => ps.setId == action.payload.setId
        ).pictures = action.payload.pictures;

        state.pictureSets.pictureSets.find(
          (ps) => ps.setId == action.payload.setId
        ).format = action.payload.format;
      } else {
        state.pictureSets.pictureSets.push({
          setId: action.payload.setId,
          format: action.payload.format,
          pictures: action.payload.pictures,
        });
      }
      return Object.assign({}, state);

    case EVENT_ADDITIONAL_PICTURES_ACTIONS.DELETE_EVENT_ADDITIONAL_PICTURES:
      state.pictureSets.pictureSets = state.pictureSets.pictureSets.filter(
        (ps) => ps.setId !== action.payload.setId
      );
      return Object.assign({}, state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/event-additional-pictures.reducer.ts